import styled from 'styled-components'

import Button from 'components/Button'
import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
`

export const ContentContainer = styled.div`
  padding: 28px 0 80px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-bottom: 30px;
  }
`

export const Title = styled(Heading2)`
  font-size: 22px;
  line-height: 30px;
  margin-top: 30px;
  margin-bottom: 6px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const Text = styled(Body)`
  font-size: 14px;
  margin: 0 auto;
  max-width: 390px;
`

export const ContentText = styled(Text)`
  margin: 28px auto 0;
  max-width: 390px;
`

export const StyledFootnote = styled.div`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  font-style: italic;
  font-weight: 500;
  line-height: 1.83;
  text-align: center;
`

export const StyledButton = styled(Button)`
  margin: 0 auto;
`

export const InvestmentTypeContainer = styled.div`
  padding: 12px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const InvestmentTitle = styled.p`
  font-size: 14px;
  line-height: 1.57;
  text-align: left;
  margin: 0;
  font-weight: 500;
  color: ${style(theme => theme.colors.slate)};
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`

export const InvestmentSubtitle = styled(InvestmentTitle)`
  color: ${style(theme => theme.colors.stone)};
  font-weight: 400;
`

export const Image = styled.div<{ image: string }>`
  width: 60px;
  height: 60px;
  background: url(${props => props.image}) no-repeat;
  background-size: contain;
`
